import React from "react";
export default function Header({ onToggleSidebar, onLogout }) {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  return (
    <header style={{ background: "white", padding: "16px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", zIndex: 10 }}>
      <button onClick={onToggleSidebar} style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer", padding: 8, borderRadius: 8 }}>☰</button>
      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: "#1A1A2E" }}>{user.full_name || "Admin"}</div>
          <div style={{ fontSize: 11, color: "#8A8A9A" }}>{user.role === "super_admin" ? "Super Administrateur" : "Agent Municipal"}</div>
        </div>
        <div style={{ width: 40, height: 40, background: "#1A5C2A", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", color: "white", fontWeight: 700, fontSize: 16 }}>
          {(user.full_name || "A")[0].toUpperCase()}
        </div>
        <button onClick={onLogout} style={{ background: "rgba(211,47,47,0.1)", border: "1px solid rgba(211,47,47,0.3)", color: "#D32F2F", padding: "8px 16px", borderRadius: 10, cursor: "pointer", fontSize: 13, fontWeight: 600, fontFamily: "Poppins" }}>
          Déconnexion
        </button>
      </div>
    </header>
  );
}